import { createFileRoute } from '@tanstack/react-router';

import { AllRecordsPage } from '~/features/home/all-records-page';

/** Every record, in a table that sorts. */
export const Route = createFileRoute('/_app/records/')({
  component: AllRecordsPage,
});
